import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  CHECK_FUNDING_TYPE_QUERY_KEY,
  CHECK_FUNDING_TYPE_URL
} from './queryConstants'

type FundingTypeCheck = {
  fundingTypeId: string
  residentId: string
}

export type FundingTypeUsageCheck = {
  instances?: unknown[]
  patterns?: unknown[]
  revisions?: unknown[]
}

type UseCheckFundingTypeReturn = {
  checkFundingTypeUsedInRota: (
    values: FundingTypeCheck
  ) => Promise<FundingTypeUsageCheck>
  isLoading: boolean
}

const useCheckFundingType = (): UseCheckFundingTypeReturn => {
  const createFunction = async (values: FundingTypeCheck) => {
    return postJSON({
      url: CHECK_FUNDING_TYPE_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    FundingTypeUsageCheck,
    unknown,
    FundingTypeCheck,
    unknown
  >([CHECK_FUNDING_TYPE_QUERY_KEY], createFunction)

  const checkFundingTypeUsedInRota = (values: FundingTypeCheck) =>
    createMutation(values)

  return {
    checkFundingTypeUsedInRota,
    isLoading
  }
}

export default useCheckFundingType
